var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.wrapper},[_vm._t("default"),_vm._v(" "),(_vm.locked)?_c('base-icon',{class:_vm.$style.lock,style:({
      width: _vm.width,
      height: _vm.height
    }),attrs:{"height":_vm.height,"width":_vm.width,"color":_vm.color,"type":"unavailable"}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }